// Widget «نوبت بعد» SCH در سربرگ مشترک مراجعه‌کننده (COMP-PATIENT-HEADER — AP-PAT-02). بخش `sch.next_appointment` فقط برای
// کاربر دارای sch.appointment.view از سرور می‌آید؛ خدمت حساس بدون نام (null).
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useTranslation } from '@phoenix/i18n';
import { toJalaliDateTime } from '@phoenix/ui';
import { Link as RouterLink } from 'react-router';
import type { PatientHeaderWidgetProps } from '../patients/headerWidgets';
import { appointmentPath } from './common';

export function NextAppointmentWidget({ section }: PatientHeaderWidgetProps) {
  const { t } = useTranslation('sch');
  const value = (key: string) => section.entries.find((entry) => entry.key === key)?.value ?? null;
  const id = value('appointment_id');
  const startsAt = value('starts_at');
  const status = value('status');
  const service = value('service');
  return (
    <Box data-testid="next-appointment-widget">
      <Typography variant="caption" color="text.secondary" component="div">
        {t('sch:summary.next_appointment')}
      </Typography>
      {id && startsAt ? (
        <Typography variant="body2">
          <Link component={RouterLink} to={appointmentPath(id)}>
            {toJalaliDateTime(startsAt)}
          </Link>
          {service ? ` · ${service}` : ''}
          {status ? ` · ${t(`sch:status.${status}`)}` : ''}
        </Typography>
      ) : (
        <Typography variant="body2">{t('sch:summary.no_next_appointment')}</Typography>
      )}
    </Box>
  );
}
